import oishiiChefJs from '../assets/img/oishii-chef-js.png';
import quoteGenerator from '../assets/img/quote-generator.png';
import clipboard from '../assets/img/clipboard.png';
import twClone from '../assets/img/tw-clone.png';
import dropdown from '../assets/img/dropdown.png';
import infinityScroll from '../assets/img/infinity-scroll.png';
import pictureInPicture from '../assets/img/picture-in-picture.png';
import jokeTeller from '../assets/img/joke-teller.png';
import darkMode from '../assets/img/dark-mode.png';


export const projectsListFront = [
  {
    title: "Light/Dark Mode",
    description: "HTML, CSS, Javascript",
    imgUrl: darkMode,
    gitHubUrl:"https://github.com/Martin-J-Larre/dark-mode",
    demoUrl:"https://martin-j-larre.github.io/dark-mode/"
  },
  {
    title: "Joke Teller",
    description: "HTML, CSS, Javascript",
    imgUrl: jokeTeller,
    gitHubUrl:"https://github.com/Martin-J-Larre/joke-teller",
    demoUrl:"https://martin-j-larre.github.io/joke-teller/"
  },
  {
    title: "Picture in Picture",
    description: "HTML, CSS, Javascript",
    imgUrl: pictureInPicture,
    gitHubUrl:"https://martin-j-larre.github.io/picture-in-picture/",
    demoUrl:"https://martin-j-larre.github.io/infinity-scroll/"
  },
  {
    title: "Infinity Scroll",
    description: "HTML, CSS, Javascript",
    imgUrl: infinityScroll,
    gitHubUrl:"https://github.com/Martin-J-Larre/infinity-scroll",
    demoUrl:"https://martin-j-larre.github.io/infinity-scroll/"
  },
  {
    title: "Dropdown Nav",
    description: "HTML, CSS, Javascript",
    imgUrl: dropdown,
    gitHubUrl:"https://github.com/Martin-J-Larre/intro-section-with-dropdown-navigation",
    demoUrl:"https://martin-j-larre.github.io/intro-section-with-dropdown-navigation/"
  },
  {
    title: "Tw Clone",
    description: "React, MUI, Firebase",
    imgUrl: twClone,
    gitHubUrl:"https://github.com/Martin-J-Larre/tw-clone",
    demoUrl:"https://martin-j-larre.github.io/tw-clone/"
  },
  {
    title: "Clipboad Landing Page",
    description: "Html, css",
    imgUrl: clipboard,
    gitHubUrl:"https://github.com/Martin-J-Larre/Clipboad-Landing-Page",
    demoUrl:"https://martin-j-larre.github.io/Clipboad-Landing-Page/"
  },
  {
    title: "Quote Generator",
    description: "Html, css, Javascript",
    imgUrl: quoteGenerator,
    gitHubUrl:"https://github.com/Martin-J-Larre/quote-generator",
    demoUrl:"https://martin-j-larre.github.io/quote-generator/"
  },
  {
    title: "Ecommerce UI",
    description: "Html, css, Javascript",
    imgUrl: oishiiChefJs,
    gitHubUrl:"https://github.com/Martin-J-Larre/ProyectoFinal-JS-CoderHouse-Larre-",
    demoUrl:"https://martin-j-larre.github.io/ProyectoFinal-JS-CoderHouse-Larre-/"
  },
];